import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl212c25g5qzedjl1 as UInt__toString_impl_dbgl21,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k36l427nkiqphd as ULong__toString_impl_f9au7k,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg3k7aad61xjb4o as UByte__toString_impl_v72jg,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee2vx1is7vlchpz as UShort__toString_impl_edaoee,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ComposerClass;
function Composer() {
  if (ComposerClass === VOID) {
    class $ {
      constructor(writer) {
        this.e2t_1 = writer;
        this.f2t_1 = true;
      }
      g2t() {
        this.f2t_1 = true;
      }
      h2t() {
        return Unit_instance;
      }
      i2t() {
        this.f2t_1 = false;
      }
      j2t() {
        this.f2t_1 = false;
      }
      k2t() {
        return Unit_instance;
      }
      l2t(v) {
        return this.e2t_1.m2t(v);
      }
      n2t(v) {
        return this.e2t_1.o2t(v);
      }
      p2t(v) {
        return this.e2t_1.o2t(v.toString());
      }
      q2t(v) {
        return this.e2t_1.o2t(v.toString());
      }
      r2t(v) {
        return this.e2t_1.s2t(fromInt(v));
      }
      t2t(v) {
        return this.e2t_1.s2t(fromInt(v));
      }
      u2t(v) {
        return this.e2t_1.s2t(fromInt(v));
      }
      v2t(v) {
        return this.e2t_1.s2t(v);
      }
      w2t(v) {
        return this.e2t_1.o2t(v.toString());
      }
      x2t(value) {
        return this.e2t_1.y2t(value);
      }
    }
    initMetadataForClass($, 'Composer');
    ComposerClass = $;
  }
  return ComposerClass;
}
function Composer_0(sb, json) {
  return json.i2o_1.a2q_1 ? new (ComposerWithPrettyPrint())(sb, json) : new (Composer())(sb);
}
var ComposerForUnsignedNumbersClass;
function ComposerForUnsignedNumbers() {
  if (ComposerForUnsignedNumbersClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.b2u_1 = forceQuoting;
      }
      u2t(v) {
        if (this.b2u_1) {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
          this.x2t(UInt__toString_impl_dbgl21(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
          this.n2t(UInt__toString_impl_dbgl21(tmp$ret$1));
        }
      }
      v2t(v) {
        if (this.b2u_1) {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
          this.x2t(ULong__toString_impl_f9au7k(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
          this.n2t(ULong__toString_impl_f9au7k(tmp$ret$1));
        }
      }
      r2t(v) {
        if (this.b2u_1) {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
          this.x2t(UByte__toString_impl_v72jg(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
          this.n2t(UByte__toString_impl_v72jg(tmp$ret$1));
        }
      }
      t2t(v) {
        if (this.b2u_1) {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$0 = _UShort___init__impl__jigrne(v);
          this.x2t(UShort__toString_impl_edaoee(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$1 = _UShort___init__impl__jigrne(v);
          this.n2t(UShort__toString_impl_edaoee(tmp$ret$1));
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnsignedNumbers');
    ComposerForUnsignedNumbersClass = $;
  }
  return ComposerForUnsignedNumbersClass;
}
var ComposerForUnquotedLiteralsClass;
function ComposerForUnquotedLiterals() {
  if (ComposerForUnquotedLiteralsClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.e2u_1 = forceQuoting;
      }
      x2t(value) {
        if (this.e2u_1) {
          super.x2t(value);
        } else {
          super.n2t(value);
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnquotedLiterals');
    ComposerForUnquotedLiteralsClass = $;
  }
  return ComposerForUnquotedLiteralsClass;
}
var ComposerWithPrettyPrintClass;
function ComposerWithPrettyPrint() {
  if (ComposerWithPrettyPrintClass === VOID) {
    class $ extends Composer() {
      constructor(writer, json) {
        super(writer);
        this.h2u_1 = json;
        this.i2u_1 = 0;
      }
      g2t() {
        this.f2t_1 = true;
        this.i2u_1 = this.i2u_1 + 1 | 0;
      }
      h2t() {
        this.i2u_1 = this.i2u_1 - 1 | 0;
      }
      i2t() {
        this.f2t_1 = false;
        this.n2t('\n');
        // Inline function 'kotlin.repeat' call
        var times = this.i2u_1;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.n2t(this.h2u_1.i2o_1.c2q_1);
          }
           while (inductionVariable < times);
      }
      j2t() {
        if (this.f2t_1)
          this.f2t_1 = false;
        else {
          this.i2t();
        }
      }
      k2t() {
        this.l2t(_Char___init__impl__6a9atx(32));
      }
    }
    initMetadataForClass($, 'ComposerWithPrettyPrint');
    ComposerWithPrettyPrintClass = $;
  }
  return ComposerWithPrettyPrintClass;
}
//region block: exports
export {
  ComposerForUnquotedLiterals as ComposerForUnquotedLiterals3v0rwxdudtla9,
  ComposerForUnsignedNumbers as ComposerForUnsignedNumbers2h1dv6l9z3aef,
  Composer_0 as Composer1pt8hwk95abxi,
};
//endregion

//# sourceMappingURL=Composers.mjs.map
